// state
export const state = {
  jackpot: false,
  guaranteedJackpot: false,
  prizes: false,
  roundId: false,
  leagueType: false,
  isRoundJackpotOverviewModalVisible: false,
  isRoundJackpotMoreInfoModalVisible: false,
}

// getters
export const getters = {
}
// mutations
export const mutations = {
  setRoundJackpotOverviewModalVisibility(state, { isVisible, ...rest }) {
    state.isRoundJackpotOverviewModalVisible = isVisible
    state.prizes = false
    state.guaranteedJackpot = false
    state.jackpot = false

    if (rest.roundId) {
      state.roundId = rest.roundId
    }
    if (rest.jackpot) {
      state.jackpot = rest.jackpot
    }
    if (rest.guaranteedJackpot) {
      state.guaranteedJackpot = rest.guaranteedJackpot
    }
    if (rest.prizes) {
      state.prizes = rest.prizes
    }
    if (rest.leagueType) {
      state.leagueType = rest.leagueType
    } else {
      state.leagueType = false
    }
  },
  setRoundJackpotMoreInfoModalVisibility(state, { isVisible, ...rest }) {
    state.isRoundJackpotMoreInfoModalVisible = isVisible
    if (!isVisible) {
      state.roundId = false
      state.jackpot = false
      state.guaranteedJackpot = false
    } else {
      if (rest.roundId) {
        state.roundId = rest.roundId
      }
      if (rest.jackpot) {
        state.jackpot = rest.jackpot
      }
      if (rest.guaranteedJackpot) {
        state.guaranteedJackpot = rest.guaranteedJackpot
      }
    }
  },
}
// actions
export const actions = {
  async openRoundJackpotOverviewModal({ commit }, params) {
    commit('setRoundJackpotOverviewModalVisibility', {
      isVisible: true,
      ...params,
    })
  },
  async closeRoundJackpotOverviewModal({ commit }) {
    commit('setRoundJackpotOverviewModalVisibility', { isVisible: false })
  },
  async openRoundJackpotMoreInfoModal({ commit }, params) {
    commit('setRoundJackpotMoreInfoModalVisibility', {
      isVisible: true,
      ...params,
    })
  },
  async closeRoundJackpotMoreInfoModal({ commit }) {
    commit('setRoundJackpotMoreInfoModalVisibility', { isVisible: false })
  },
}
